import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import appConstant from '../../constants';
import ah from '../../helpers/Axhelper';
import * as actions from "./actions";

let defLimit = 50;
let defSortColumn = 'created';
let defSortDirection = 'desc';

let urlAll = appConstant.baseUrl+"customernotifications/all/";
let urlDetails = appConstant.baseUrl+"customernotifications/details/";
let urlSearch = appConstant.baseUrl+"customernotifications/search/"; 
let urlDelete = appConstant.baseUrl+"customernotifications/";
let urlInsert = appConstant.baseUrl+"customernotifications/";
let urlUpdate = appConstant.baseUrl+"customernotifications/";

const computeListUrl = (searchField, sortColumn, sortDirection, limit) => {
    //console.log("computeListUrl -> searchField, sortColumn, sortDirection, limit", searchField, sortColumn, sortDirection, limit);
    let computedSort = sortColumn || defSortColumn;
    let computedDirection = sortDirection || defSortDirection;
    let computedLimit = limit || defLimit; 
    let computedSearchUrl = urlSearch.concat(encodeURIComponent(searchField)).concat(`?sortcol=${computedSort}&sortdir=${computedDirection}&limit=${computedLimit}`);
    let computedAllUrl = urlAll.concat(`?sortcol=${computedSort}&sortdir=${computedDirection}&limit=${computedLimit}`);

    if(!searchField || searchField.length===0) { 
        return computedAllUrl 
    } else { 
        return computedSearchUrl 
    }
}

function* getItems(actionObject) {
    let {searchField, sortColumn, sortDirection, limit} = actionObject.payload;
    let currentUrl = computeListUrl(searchField, sortColumn, sortDirection, limit);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.customernotificationsGetError(response.error));
    } else {
        yield put(actions.customernotificationsGetSuccess(response.data,response.headers["x-total-count"]));
    }
}

/* eslint require-yield: 0 */  
function* setSearch(actionObject) {
    if(actionObject.payload.length>=3){
        getItems(actionObject);
    }
}

function* loadMore(actionObject) {
    let {searchField, sortColumn, sortDirection, limit} = actionObject.payload;
    let currentUrl = computeListUrl(searchField, sortColumn, sortDirection, limit);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.customernotificationsLoadMoreError(response.error));
    } else {
        yield put(actions.customernotificationsLoadMoreSuccess(response.data,response.headers["x-total-count"]));
    }
}

function* deleteItem(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDelete.concat(id);
    const response = yield call(ah.sendDeleteAsync,currentUrl);
    if(response.error){
        yield put(actions.customernotificationsDeleteItemError(response.error));
    } else {
        yield put(actions.customernotificationsDeleteItemSuccess(response.data));
    }
}

function* getDetails(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDetails.concat(id);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.customernotificationsGetDetailsError(response.error));
    } else {
        yield put(actions.customernotificationsGetDetailsSuccess(response.data));
    }
}

function* insert(actionObject) {
    let item = actionObject.payload;
    const response = yield call(ah.sendPostAsync,urlInsert,item);
    if(response.error){
        yield put(actions.customernotificationsInsertError(response.error));
    } else {
        yield put(actions.customernotificationsInsertSuccess(response.data));
    }
}

function* loadUpdate(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDetails.concat(id);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.customernotificationsLoadUpdateError(response.error));
    } else {
        yield put(actions.customernotificationsLoadUpdateSuccess(response.data));
    }
}

function* update(actionObject) {
    console.log("function*update -> actionObject", actionObject);
    let id = actionObject.payload.id;
    let currentUrl = urlUpdate.concat(id);
    console.log("function*update -> currentUrl", currentUrl);
    const response = yield call(ah.sendPutAsync,currentUrl, actionObject.payload.item);
    if(response.error){
        yield put(actions.customernotificationsUpdateError(response.error));
    } else {
        yield put(actions.customernotificationsUpdateSuccess(response.data));
    }
}

export function* watchActions() {
    yield takeEvery('CUSTOMERNOTIFICATIONS_GET', getItems);
    yield takeEvery('CUSTOMERNOTIFICATIONS_SET_SEARCH_FIELD', setSearch);
    yield takeEvery('CUSTOMERNOTIFICATIONS_LOAD_MORE', loadMore);
    yield takeEvery('CUSTOMERNOTIFICATIONS_DELETE_ITEM', deleteItem);
    yield takeEvery('CUSTOMERNOTIFICATIONS_GET_DETAILS', getDetails);
    yield takeEvery('CUSTOMERNOTIFICATIONS_INSERT', insert);
    yield takeEvery('CUSTOMERNOTIFICATIONS_LOAD_UPDATE', loadUpdate);
    yield takeEvery('CUSTOMERNOTIFICATIONS_UPDATE', update);
}

export default function* rootSaga() {
    yield all([
        fork(watchActions)
    ]);
}